import React, { useEffect, useRef, useState } from 'react';
import { Image, message, Progress, Result, Tooltip, Upload } from 'components/shared/AntComponent';
import ImgCrop from 'antd-img-crop';
import { Button } from 'components/shared/ButtonComponent';
import { Checkbox, Form, Input, InputNumber, Select } from 'components/shared/FormComponent';
import { useSelector, useDispatch, url2 } from 'components/shared/CompVariables';
import { formatter, parser, validatePhone } from 'components/shared/FormValidators';
import { LoadingOutlined, ReloadOutlined } from 'components/shared/AntIcons';
import { getCountry, getState } from 'services/actions/commonServiceAction';
import LoginImg from 'assets/img/login-image.png';
import EEGLogo from 'assets/img/brandname.png';
import 'assets/styles/auth.scss';
import 'assets/styles/form.scss';
import { useNavigate } from 'react-router-dom';
import { signUpAccount } from 'services/actions/authAction';
import { loadCaptchaEnginge, LoadCanvasTemplateNoReload, validateCaptcha } from 'react-simple-captcha';
import { PhoneInput } from 'react-international-phone';
import { parsePhoneNumberFromString } from 'libphonenumber-js';


const { Dragger } = Upload;

const SignupAccount: React.FC = () => {
    const [form] = Form.useForm();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [countryCode, setCountryCode] = useState();
    const { loading2, loading3 } = useSelector((state: any) => state.commonData);
    const { loading12, success12, error12, accountInfo } = useSelector((state: any) => state.auth);
    const { resultDocProgress } = useSelector((state: any) => state.upload);

    const [fileList, setFileList]: any = useState([]);
    const [showSuccessmsg, setShowSuccessmsg] = useState(false);
    const successmsg = showSuccessmsg ? success12 : false;
    const [showErrormsg, setShowErrormsg] = useState(false);
    const errormsg = showErrormsg ? error12 : false;
    const { countryInfo, stateInfo } = useSelector((state: any) => state.commonData);
    const [baaFile, setBaaFile]: any = useState(null);
    const [showLogo, setShowLogo] = useState(false);

    const [userCaptcha, setUserCaptcha] = useState('');
    const [captchaValid, setCaptchaValid] = useState(false);
    const [errorMsg, setErrorMsg] = useState('');
    const captchaRef1 = useRef(null);

    const countryOptions: any = countryInfo?.data?.map((item: any) => {
        return {
            label: item.countryname,
            value: item.id.toString(),
            key: item.id,
        };
    });

    const stateOptions: any = stateInfo?.data?.map((item: any) => {
        return {
            label: item.statename,
            value: item.id.toString(),
            key: item.id,
        };
    });

    const props1 = {
        onRemove: (file: any) => {
            const index = fileList.indexOf(file);
            const newFileList = fileList.slice();
            newFileList.splice(index, 1);
            setFileList(newFileList);
        },
        beforeUpload: () => {
            return false;
        },
        fileList,
    };

    const changeFile = (info: any) => {
        setFileList(info?.fileList);
    };

    const getStateDetails = (value: any) => {
        const inputJson = {
            countryid: value,
        };
        dispatch(getState(inputJson) as any);
    };

    useEffect(() => {
        const inputJson = {
            countryid: 0,
        };
        dispatch(getCountry(inputJson) as any);
    }, []);

    useEffect(() => {
        if (countryInfo?.data) {
            getStateDetails(231);
        }
    }, [countryInfo]);

    const handleSubmit = async () => {
        const formData = new FormData();
        try {
            const value = await form.validateFields();
            const inputJson = {
                AccountID: 0,
                account_name: value.accountName?.trim() || '',
                first_name: value.firstName?.trim() || '',
                last_name: value.lastName?.trim() || '',
                contact_phone: value.contactNo?.toString() || '',
                contact_email: value.email?.trim() || '',
                contact_fax: value.fax || '',
                contact_address: value.address || '',
                contact_address2: value.address2 || '',
                country: value.country || '231',
                state: value.state || '',
                city: value.city || '',
                zip: value.zip || '',
                status: 'Active',
            };
            let file = '';
            if (fileList) {
                file = fileList[0]?.originFileObj;
            } else {
                file = '';
            }
            if (baaFile && baaFile.length > 0) {
                baaFile.forEach((file: any) => {
                    formData.append('baa_docs', file.originFileObj);
                });
            } else {
                formData.append('baa_docs', ''); // Handle no files case
            }
            if (validateCaptcha(userCaptcha) == false) {
                // setErrorForm(true);
                setCaptchaValid(true);
                if (userCaptcha == '') {
                    setErrorMsg('Please fill in the captcha.');
                } else {
                    setErrorMsg('Captcha does not match.');
                    setUserCaptcha('');
                    loadCaptchaEnginge(6, '#dfdfdf');
                }
            } else {
                setCaptchaValid(false);
                formData.append('File', file);
                formData.append('InputJson', JSON.stringify(inputJson));
                dispatch(signUpAccount(formData) as any);
                setShowErrormsg(true);
                setShowSuccessmsg(true);
                // setValidatePhq(false);
                // validphq = false;
                // setShowModal(true);
            }
            // formData.append('baa_docs',file1);


        } catch (errorInfo) {
            console.log('Failed:', errorInfo);
        }
    };

    useEffect(() => {
        form.setFieldsValue({
            accountName: '',
            firstName: '',
            lastName: '',
            contactNo: '',
            email: '',
            fax: '',
            address: '',
            country: '231',
            state: '',
            city: '',
            zip: '',
        });
    }, [])

    useEffect(() => {
        if (successmsg) {
            setShowSuccessmsg(false);
            message.success('Account Created successfully');
        }
        if (errormsg) {
            setShowErrormsg(false);
            if (error12.data) {
                message.error(error12.data);
            } else {

                message.error("Account couldn't be added");

            }
        }
    }, [successmsg, errormsg]);


    const gotoLogin = () => {
        navigate('/login');
    }
    const changeFileEO = (info) => {
        setBaaFile(info?.fileList);
    };
    useEffect(() => {
        const checkCanvasReady = () => {
            const canvas: any = document.getElementById('canv');
            if (canvas && canvas.getContext) {
                loadCaptchaEnginge(6);
            } else {
                setTimeout(checkCanvasReady, 100); // Retry after a short delay
            }
        };
        checkCanvasReady();
    }, []);

    useEffect(() => {
        const checkCanvasReady = () => {
            const canvas: any = document.getElementById('canv');
            if (canvas && canvas.getContext) {
                loadCaptchaEnginge(6, '#dfdfdf');
            } else {
                setTimeout(checkCanvasReady, 100); // Retry after a short delay
            }
        };
        checkCanvasReady();
    }, []);
    const onPreview = async (file) => {
        let src = file.url || file.preview;
        if (!src) {
            src = await new Promise<string>((resolve) => {
                const reader = new FileReader();
                reader.readAsDataURL(file.originFileObj);
                reader.onload = () => resolve(reader.result as string);
            });
        }
        const imgWindow = window.open("");
        if (imgWindow) {
            imgWindow.document.write(`<html><body><img src="${src}" style="max-width: 100%; height: auto;" /></body></html>`);
            imgWindow.document.close();
        }
    };
    const reloadCaptcha = () => {
        loadCaptchaEnginge(6, '#dfdfdf');
    };


    return (
        <div className="login-container account-signup-cont pnt-intake-form">
            {success12 ?
                <div className="p-5 mt-5">
                    <Result
                        className="p-5"
                        status="success"
                        title={[
                            <div key="resultinfo">
                                <h3 className="fw-normal mb-3 text-dark">Request for Account creation submitted successfully!</h3>
                                <div className="d-flex flex-row justify-content-center">
                                    <h4 className="fw-normal text-secondary fs-19">
                                        Your reference number is
                                        <span className="sub-title-req text-blue fs-20 fw-bold" >
                                            {accountInfo ? " " + accountInfo?.data?.encrypt_accountNumber || accountInfo?.data?.encoded_accountNumber : ""}
                                        </span>.
                                    </h4>
                                </div>
                            </div>,
                        ]}
                        extra={[
                            <React.Fragment key="content">
                                {/* <Button type="primary" className="mx-auto text-center" key="console" onClick={() => history(userRole === 'staff' ? '/view-request' : '/new-request')}>
                                            {userRole !== 'staff' ? 'Back to Request in Pipeline' : 'Back to Order Management'}
                                        </Button> */}
                            </React.Fragment>
                        ]}
                    />
                </div> : <>
                    <div className="text-center p-3 res-img">
                        <Image src={EEGLogo} alt="eeg-logo" width="30%" preview={false} className="res-img" />
                    </div>
                    <div className="h-100 row m-0">
                        <div className="login-bg-container text-center h-100 col-md-6">
                            <Image src={LoginImg} alt="login-img" preview={false} height="100%" width="auto" className="login-img" />
                        </div>
                        <div className="m-auto h-100 login-right-cont d-flex align-items-center col-md-5 bg-white">
                            <div className="my-auto text-center">
                                <Image src={EEGLogo} alt="eeg-logo" width="55%" className="eeg-logo" preview={false} />
                                <div className="eeg-img">
                                    <Image src={LoginImg} alt="login-img" preview={false} height="60%" width="auto" className="login-img-right" />
                                </div>
                                {/* <h1 className="text-dark mt-3 text-center">Welcome!</h1>
                                <h4 className="text-secondary fw-normal text-center">Create your Account</h4> */}
                                <Form form={form} className="mt-4 w-100" layout="vertical" autoComplete="off" onFinish={handleSubmit}>
                                    <h5 className='text-start ps-2 fs-18'>Account Information</h5>
                                    <div className='px-2 pb-0 sign-up-acc'>
                                        <div className="row mx-0 mb-4 bg-light border pt-2">
                                            <Form.Item name="accountName" label="Practice/Business name" className="col-md-4" rules={[{ required: true, message: 'This field is required!' }]}>
                                                <Input />
                                            </Form.Item>
                                            <Form.Item name="firstName" label="First name" className="col-md-4" rules={[{ required: true, message: 'This field is required!' }]}>
                                                <Input />
                                            </Form.Item>
                                            <Form.Item name="lastName" label="Last name" className="col-md-4" rules={[{ required: true, message: 'This field is required!' }]}>
                                                <Input />
                                            </Form.Item>
                                        </div>
                                        <h5 className='text-start ps-0 fs-18'>Contact Information</h5>
                                        <div className='row mx-0 bg-light border pt-2 mb-4'>

                                            <Form.Item
                                                name="contactNo"
                                                label="Contact phone"
                                                className="col-md-4"
                                                rules={[
                                                    // { required: true, message: 'Please enter contact number' },
                                                    {
                                                        validator: (_, value) => {
                                                            if (!value) {
                                                                return Promise.resolve(); // ✅ not mandatory
                                                            }

                                                            const phoneNumber = parsePhoneNumberFromString(value);

                                                            if (phoneNumber && phoneNumber.isValid()) {
                                                                return Promise.resolve();
                                                            }

                                                            return Promise.reject(new Error('Invalid phone number'));
                                                        },
                                                    }
                                                ]}
                                            >
                                                <PhoneInput
                                                    defaultCountry="us"
                                                    value={countryCode}
                                                    onChange={(phone: any) => {
                                                        setCountryCode(phone);
                                                        form.setFieldValue('contactNo', phone); // sync with Form
                                                    }}
                                                // onChange={(phone: any) => setCountryCode(phone)}
                                                />
                                            </Form.Item>

                                            <Form.Item
                                                name="email"
                                                label="Email"
                                                className="col-md-4"
                                                rules={[
                                                    { required: true, message: 'This field is required!' },
                                                    { type: 'email', message: 'Enter valid mail address!' },
                                                ]}
                                            >
                                                <Input />
                                            </Form.Item>
                                            <Form.Item name="country" label="Country" className="col-md-4">
                                                <Select
                                                    showSearch
                                                    getPopupContainer={(trigger) => trigger.parentNode}
                                                    onChange={getStateDetails}
                                                    className='text-start'
                                                    optionFilterProp="children"
                                                    filterOption={(input, option: any) => {
                                                        return option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0 || option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0;
                                                    }}
                                                    notFoundContent={
                                                        <div className="text-center p-4">
                                                            {loading2 ? (
                                                                <span>
                                                                    <LoadingOutlined />
                                                                    Loading...
                                                                </span>
                                                            ) : (
                                                                <span>No country available</span>
                                                            )}
                                                        </div>
                                                    }
                                                    filterSort={(optionA, optionB) => (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())}
                                                    options={countryOptions}
                                                />
                                            </Form.Item>
                                            {/* <Form.Item name="fax" label="Fax" className="col-md-4">
                                                <Input />
                                            </Form.Item> */}
                                            <Form.Item name="address" label="AddressLine1" className="col-md-12">
                                                <Input />
                                            </Form.Item>
                                            <Form.Item name="address2" label="AddressLine2" className="col-md-12">
                                                <Input />
                                            </Form.Item>
                                            <Form.Item name="city" label="City/Locality" className="col-md-4">
                                                <Input />
                                            </Form.Item>
                                            <Form.Item name="state" label="State/Province/Region" className="col-md-4">
                                                <Select
                                                    showSearch
                                                    options={stateOptions}
                                                    optionFilterProp="children"
                                                    className='text-start'
                                                    filterOption={(input: any, option: any) => {
                                                        return option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0 || option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0;
                                                    }}
                                                    filterSort={(optionA, optionB) => (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())}
                                                    notFoundContent={
                                                        <div className="text-center p-4">
                                                            {loading3 ? (
                                                                <span>
                                                                    <LoadingOutlined />
                                                                    Loading...
                                                                </span>
                                                            ) : (
                                                                <span>No state available</span>
                                                            )}
                                                        </div>
                                                    }
                                                    getPopupContainer={(trigger) => trigger.parentNode}
                                                />
                                            </Form.Item>

                                            <Form.Item name="zip" label="Postal/Zip code" className="col-md-4">
                                                <Input />
                                            </Form.Item>

                                        </div>
                                        <div className="text-start mb-3">
                                            <Checkbox className='text-start fs-16' defaultChecked={showLogo} checked={showLogo} onChange={(e) => setShowLogo(e.target.checked)}>Click here if you have logo</Checkbox>
                                        </div>
                                        {/* <h5 className='text-start ps-0 fs-18'>Upload Logo</h5> */}
                                        {showLogo ?
                                            <div className='row mx-0 bg-light border pt-2 px-3'>
                                                <Form.Item label="Upload logo" name="uploadLogo" className="col pe-2 ps-0" rules={[{ required: true, message: 'This field is required' }]}>
                                                    <div>
                                                        <ImgCrop aspectSlider showReset aspect={180 / 80} beforeCrop={(file: any) => {
                                                            // console.log('Before crop:', file);
                                                            return true; // Allow crop
                                                        }}>
                                                            <Dragger
                                                                // {...props1}
                                                                name="file"
                                                                multiple={false}
                                                                maxCount={1}
                                                                // beforeUpload={() => false}
                                                                fileList={fileList || []}
                                                                listType="picture-card"
                                                                onChange={changeFile}
                                                                onPreview={onPreview}
                                                                accept={'.png,.jpg,.jpeg'}
                                                            >
                                                                <p className="ant-upload-drag-icon"></p>
                                                                <p className="ant-upload-text">Click or drag file to this area to upload</p>
                                                                <p className="ant-upload-hint">Upload Logo here</p>

                                                            </Dragger>
                                                        </ImgCrop>
                                                    </div>
                                                </Form.Item>
                                                {/* <Form.Item name="baaDoc" label="Upload BAA Document" className="col pe-0 mb-0" valuePropName="baaDoc">
                                                <div>
                                                    <Upload.Dragger
                                                        name="file"
                                                        multiple={true}
                                                        maxCount={1}
                                                        beforeUpload={() => false}
                                                        fileList={baaFile || []}
                                                        listType="picture-card"
                                                        accept=".pdf"
                                                        onChange={changeFileEO}
                                                    >
                                                        <p className="ant-upload-drag-icon"></p>
                                                        <p className="ant-upload-text">Click or drag file to this area to upload</p>
                                                        <p className="ant-upload-hint mb-0">File size limit is 50MB. Supported file format is PDF.</p>
                                                    </Upload.Dragger>
                                                </div>
                                            </Form.Item> */}
                                            </div> : ""}

                                    </div>
                                    <div className="form-group mt-4">
                                        <div className="col mt-3 captcha-container">
                                            <div ref={captchaRef1} className="captcha-text d-flex">
                                                <div className="custom-captcha-container p-1 me-2">
                                                    <LoadCanvasTemplateNoReload className="custom-captcha-canvas" />
                                                </div>
                                                <Tooltip title="Reload Captcha" className="mt-0">
                                                    <ReloadOutlined className="reload-icon" onClick={reloadCaptcha} />
                                                </Tooltip>
                                            </div>
                                        </div>

                                        <div className="col-3 mt-3 captcha-value">
                                            <div>
                                                <Input placeholder="Enter Captcha Value" value={userCaptcha} onChange={(e) => setUserCaptcha(e.target.value)} />
                                            </div>
                                        </div>
                                        {captchaValid ? <div className="text-danger text-start mt-2 me-3">{errorMsg}</div> : ''}
                                    </div>


                                    {loading12 ? (<div className='text-end'>
                                        <Progress size={[485, 20]} percent={resultDocProgress} percentPosition={{ align: 'center', type: 'inner' }} className='mt-2' strokeColor={{ from: '#108ee9', to: '#87d068' }} /> </div>
                                    ) : (
                                        ''
                                    )}

                                    <div className='d-flex w-100 mb-2 px-0 align-items-center'>
                                        <div>
                                            <a className="a-link fs-16 text fw-600 text-decoration-underline mt-2 ps-0" onClick={gotoLogin}>Back to Login?
                                            </a>
                                        </div>
                                        <div className="ms-auto">
                                            <Button type="primary" htmlType="submit" loading={loading12} className=" fs-17 fw-bold my-auto">
                                                Sign Up
                                            </Button>
                                        </div>
                                    </div>
                                </Form>
                            </div>
                        </div>
                    </div>
                </>}
        </div>
    );
};

export default SignupAccount;
